module.exports = __webpack_public_path__ + "img/newsBanner.d5013b9b.jpg";